
import {
  schema, normalize
} from 'normalizr';

// Define answer schema
const instructorSchema = new schema.Entity('instructors')
const instructorListSchema = [instructorSchema]

export function adaptInstructorsToStore({ data }) {
  const entries = normalize(data.results, instructorListSchema)

  return {
    entries: entries.entities.instructors,
    count: data.count,
    next: data.next,
    previous: data.previous,
    results: data.results
  }
}